<template>
  <div
    v-if="hasHazardousCargo || hazardCategory"
    class="hazard-badge"
  >
    <Tooltip :title="hazardTooltipTitle">
      <Badge
        :color="EBadgeColor.gold"
        :size="size"
      >
        <DangerousCargoSvg :class="{ 'hazard-badge__hazard-icon': hazardCategory }" />
        <template v-if="hazardCategory">
          {{ hazardCategory }}
        </template>
      </Badge>
    </Tooltip>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  PropType,
} from 'vue';

import DangerousCargoSvg from '@/assets/svg/16x16/dangerous-cargo.svg';
import { Badge, Tooltip } from '@/ui';
import { EBadgeColor, ESize } from '@/ui/types';
import tt from '@/i18n/utils/translateText';

export default defineComponent(
  {
    name: 'HazardBadge',
    components: {
      DangerousCargoSvg,
      Badge,
      Tooltip,
    },
    props: {
      hasHazardousCargo: {
        type: Boolean,
        default: false,
      },
      hazardCategory: {
        type: [String, null] as PropType<string | null>,
        default: null,
      },
      size: {
        type: String as PropType<ESize>,
        default: ESize.small,
      },
    },
    setup(props) {
      const hazardTooltipTitle = computed(() => {
        if (props.hasHazardousCargo && props.hazardCategory) return `${tt('order.shared.hazardousCargo')}. ${tt('order.newOrderForm.orderHazardCategory')}: ${props.hazardCategory}`;
        if (props.hasHazardousCargo && !props.hazardCategory) return tt('order.shared.hazardousCargo');
        if (props.hazardCategory) return `${tt('order.newOrderForm.orderHazardCategory')}: ${props.hazardCategory}`;
        return '';
      });

      return {
        EBadgeColor,
        hazardTooltipTitle,
      };
    },
  },
);
</script>

<style lang="scss" src="./styles.scss" />
